module.exports = __webpack_public_path__ + "media/images/symbol-defs-e41159e84b4e509b57943cb490b2ba36.svg";